import styled from "styled-components";

export const Column = styled.div<{ $withDivider?: boolean }>`
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  min-height: 100%;
  flex-direction: column;
  padding-bottom: var(--spacing-xl, 24px);
  border-right: ${({ $withDivider }) =>
    $withDivider ? "1px solid var(--color-border, #c5c6ca)" : "none"};
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm, 8px);
  padding: var(--spacing-lg, 16px) var(--spacing-xl, 24px);
`;

export const Dot = styled.span<{ $variant: "live" | "changes" }>`
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  margin-top: 7px;
  border-radius: 50%;
  background: ${({ $variant }) =>
    $variant === "live"
      ? "var(--color-green-700, #1b7a3a)"
      : "var(--color-yellow-500, #fecf00)"};
`;

export const HeaderTextBlock = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.span<{ $variant: "live" | "changes" }>`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.25rem;
  color: ${({ $variant }) =>
    $variant === "live"
      ? "var(--color-green-700, #1b7a3a)"
      : "var(--color-yellow-950, #463500)"};
`;

export const HeaderSubtitle = styled.span`
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-subtle, #7d7e84);
`;

export const HeaderAside = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: var(--spacing-xxs, 4px);
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-subtle, #7d7e84);

  .avatar {
    width: 16px;
    height: 16px;
    font-size: 9px;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 var(--spacing-xl, 24px);
  background: var(--color-background, #fff);
  border: 1px solid var(--color-border, #c5c6ca);
  border-radius: var(--radius-md, 8px);
  overflow: hidden;
`;

export const SettingsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm, 8px);
  padding: var(--spacing-lg, 16px) var(--spacing-xl, 24px) 0;
`;

export const SettingsTitle = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-subtle, #7d7e84);
`;

export const SettingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-sm, 8px);
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--color-gray-950, #19191b);
`;
